export default function archivedReportInstanceDirective() {
  return {
    template: require('./report-instance.html'),
    controller: 'ArchivedReportInstanceController',
    controllerAs: 'archivedReportInstanceVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      reportInstance: '=',
    },
  };
}
